
//下单步骤dom监控扩展类
class Step {
  private config: any = {};
  constructor(config: { selector: string, extFieldName?: string }) {
    this.config = config;
  }
  getExt() {
    let el = document.querySelector(this.config.selector);
    let step;
    if (el) {
      let activeStep = el.querySelector('.winitd-steps-item-active');
      if (activeStep) {
        step = activeStep.getAttribute('code') || activeStep.getAttribute('id');
      }
    }
    if (!step) return null;
    return {
      [this.config.extFieldName || 'processCode']: step,
    };
  }
  private createObserver() {
  }
  start() {

  };
  stop() {
  }
}

export default Step;
